import "./TypingIndicator.css";

export const TypingIndicator = () => (
  <div className="typing-indicator">
    <div className="typing-dots">
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="typing-dot"
          style={{ animationDelay: `${(i - 1) * 0.2}s` }}
        />
      ))}
    </div>
  </div>
);
